export { default as adaptive_icon } from './adaptive-icon.png';
export { default as adaptive_icon_dev } from './adaptive-icon-dev.png';
export { default as arrow_left } from './arrow-left.png';
export { default as attachments_dicom_do } from './attachments-dicom-do.png';
export { default as attachments_dicom_dont } from './attachments-dicom-dont.png';
export { default as component_avatar_image } from './component-avatar-image.png';
export { default as favicon } from './favicon.png';
export { default as favicon_dev } from './favicon-dev.png';
export { default as half_logo } from './half-logo.png';
export { default as icon } from './icon.png';
export { default as icon_dev } from './icon-dev.png';
export { default as not_found } from './not-found.png';
export { default as oauth_apple } from './oauth-apple.png';
export { default as oauth_google } from './oauth-google.png';
export { default as oauth_microsoft } from './oauth-microsoft.png';
export { default as primum_default_avatar } from './primum-default-avatar.png';
export { default as primum_expert_avatar_badge } from './primum-expert-avatar-badge.png';
export { default as primum_header } from './primum-header.png';
export { default as primum_logo_light } from './primum-logo-light.png';
export { default as primum_logo_light_ribbon } from './primum-logo-light-ribbon.png';
export { default as primum_logo_mark_2x } from './primum-logo-mark-2x.png';
export { default as primum_logo_mark_ribbon_2x } from './primum-logo-mark-ribbon-2x.png';
export { default as primum_logo_mark_ribbon } from './primum-logo-mark-ribbon.png';
export { default as primum_logo_mark_reverse_2x } from './primum-logo-mark-reverse-2x.png';
export { default as primum_logo_mark_reverse_ribbon_2x } from './primum-logo-mark-reverse-ribbon-2x.png';
export { default as primum_logo_mark } from './primum-logo-mark.png';
export { default as primum_logo } from './primum-logo.png';
export { default as primum_mark_light } from './primum-mark-light.png';
export { default as primum_mark } from './primum-mark.png';
export { default as primum_mark_ribbon } from './primum-mark-ribbon.png';
export { default as promotional_chat } from './promotional_chat.png';
export { default as promotional_network } from './promotional_network.png';
export { default as promotional_testimonials } from './promotional_testimonials.png';
export { default as splash_icon } from './splash-icon.png';
export { default as Tutorial_1 } from './Tutorial-1.png';
export { default as Tutorial_2 } from './Tutorial-2.png';
export { default as Tutorial_3 } from './Tutorial-3.png';
export { default as Tutorial_4 } from './Tutorial-4.png';
export { default as Tutorial_5 } from './Tutorial-5.png';
